module.exports = __webpack_public_path__ + "static/img/s69.259c85ce.png";